export const feathersPiniaAutoImport = {
  'feathers-pinia': [
    'useServiceInstance',
    'useInstanceDefaults',
    'useDataStore',
    'useAuth',
    'createPiniaClient',
    'defineGetters',
    'defineSetters',
    'defineValues',
    'useBackup',
  ],
}
